// --- In your Firebase initialization file (e.g., firebase.js) ---
// (Assuming you have this set up somewhere)
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your complete Firebase config object (from Firebase Project settings -> General -> Your apps)
const firebaseConfig = {
  apiKey: "AIzaSyBqK4veCNLWoncjOK9en4ny7TA78CqEDXA",
  authDomain: "barcode2sheets-web.firebaseapp.com",
  projectId: "barcode2sheets-web",
  storageBucket: "barcode2sheets-web.firebasestorage.app",
  messagingSenderId: "719368337672",
  appId: "1:719368337672:web:2fdcaa76d0548fc17614bd",
  measurementId: "G-VRXSYQC9EX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get the Analytics instance
export const analytics = getAnalytics(app); // Export it so you can use it elsewhere
